import { render, staticRenderFns } from "./pictureControl.vue?vue&type=template&id=070dfea6&scoped=true"
import script from "./pictureControl.vue?vue&type=script&lang=js"
export * from "./pictureControl.vue?vue&type=script&lang=js"
import style0 from "./pictureControl.vue?vue&type=style&index=0&id=070dfea6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070dfea6",
  null
  
)

export default component.exports